import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from "../assets/Logo.png"
import Logo from "../assets/Logo1.png";

const Sidebar = () => {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState({
        userManagement: false,
    });

    // Map paths to link names
    const getActiveLink = () => {
        const path = location.pathname;
        if (path === '/dashboard') return 'dashboard';
        if (path === '/resellers') return 'Resellers';
        if (path === '/referrals') return 'Referrals';
        if (path === '/beneficaries') return 'Beneficaries';
        if (path === '/commissions') return 'Commissions';
        if (path === '/settlement') return 'Settlement';
        if (path === '/monthlyinvoice') return 'Monthly invoices';
        if (path === '/profile') return 'Profile';
        if (path === '/permissions') return 'Permissions';
        if (path === '/roles') return 'Roles';
        if (path === '/users') return 'Users';
        return '';
    };

    const activeLink = getActiveLink();

    const toggleMenu = (menuName) => {
        setMenuOpen((prevState) => ({
            ...prevState,
            [menuName]: !prevState[menuName],
        }));
    };

    return (
        <>
            <style>{`
                @keyframes gradient {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }
                body {
                    background: #F4F7FB;
                    background-size: 400% 400%;
                    animation: gradient 15s ease infinite;
                    height: 100vh;
                }
                .sidebar-link.active, .sidebar-link:hover {
                    background-color: #635BFF;
                    color: white !important;
                    border-radius: 0.75rem;
                    box-shadow: 0 2px 8px rgba(99, 91, 255, 0.3);
                }
                .sidebar-link.active span, .sidebar-link:hover span {
                    color: white !important;
                }
                .logout-link:hover, .logout-link.active {
                    background-color: #DC2626;
                    color: white !important;
                    border-radius: 0.75rem;
                    box-shadow: 0 2px 8px rgba(255, 99, 71, 0.3);
                }
                .logout-link:hover span, .logout-link.active span {
                    color: white !important;
                }
                #user-management-menu {
                    transition: max-height 0.3s ease-in-out;
                }
            `}</style>

            <div className="bg-gray-100">
                <div className="fixed bg-white w-full lg:w-72 h-screen shadow-lg px-6 py-8">
                    {/* Logo */}
                    <div className="flex items-center mb-6 p-2">
                        <div className="mb-2 flex items-center justify-center">
                                        <img src={Logo} alt="Company Logo" className="h-20 md:h-24" />
                                      </div>
                      {/* <img src={logo} alt="Logo" className="w-14 h-14 mr-1 rounded-md" />
                      <div className="w-full mt-5 px-2">
                        <h1 className="text-2xl font-bold text-[#635BFF] leading-tight">Caroset</h1>
                        <span className="block text-sm text-right text-gray-600 font-serif tracking-wide">Partner</span>
                      </div> */}
                    </div>
                  
                    {/* Sidebar Items */}
                    <div className="space-y-6">
                        {/* Home Section */}
                        <div>
                            <h5 className="text-xs font-semibold sidebar-heading mb-2 uppercase">Home</h5>
                            <ul className="space-y-2">
                                <li>
                                    <Link to="/dashboard" className={`flex items-center p-2 sidebar-link ${activeLink === 'dashboard' ? 'active' : ''}`}>
                                        <span className="material-icons mr-3">dashboard</span>
                                        <span className="iconify text-xl mr-3" ></span>
                                        Dashboard
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/resellers" className={`flex items-center p-2 sidebar-link ${activeLink === 'Resellers' ? 'active' : ''}`}>
                                        <span className="material-icons mr-3">groups_2</span>
                                        <span className="iconify text-lg mr-3" ></span>
                                        Resellers
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/referrals" className={`flex items-center p-2 sidebar-link ${activeLink === 'Referrals' ? 'active' : ''}`}>
                                        <span className="material-icons mr-3">sync_alt</span>
                                        <span className="iconify text-lg mr-3" ></span>
                                        Referrals
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/beneficaries" className={`flex items-center p-2 sidebar-link ${activeLink === 'Beneficaries' ? 'active' : ''}`}>
                                        <span className="material-icons mr-3">group</span>
                                        <span className="iconify text-lg mr-3" ></span>
                                        Beneficaries
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/commissions" className={`flex items-center p-2 sidebar-link ${activeLink === 'Commissions' ? 'active' : ''}`}>
                                        <span className="material-icons mr-3">payments</span>
                                        <span className="iconify text-lg mr-3" ></span>
                                        Commissions
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/settlement" className={`flex items-center p-2 sidebar-link ${activeLink === 'Settlement' ? 'active' : ''}`}>
                                        <span className="material-icons mr-3">wallet</span>
                                        <span className="iconify text-lg mr-3" ></span>
                                        Settlement
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/monthlyinvoice" className={`flex items-center p-2 sidebar-link ${activeLink === 'Monthly invoices' ? 'active' : ''}`}>
                                        <span className="material-icons mr-3">receipt_long</span>
                                        <span className="iconify text-lg mr-3" ></span>
                                        Monthly invoices
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/profile" className={`flex items-center p-2 sidebar-link ${activeLink === 'Profile' ? 'active' : ''}`}>
                                        <span className="material-icons mr-3">account_circle</span>
                                        <span className="iconify text-lg mr-3" ></span>
                                        Profile
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        
                        {/* Auth Section */}
                        <div>
                            <h5 className="text-xs font-semibold sidebar-heading mb-2 uppercase">Auth</h5>
                            <ul className="space-y-2">
                                <li>
                                    <Link to="#" 
                                        className="flex items-center p-2 sidebar-link" 
                                        onClick={() => toggleMenu('userManagement')}
                                    >
                                        <span className="material-icons mr-3">manage_accounts</span>
                                        <span className="iconify text-lg mr-3" ></span>
                                        User Management
                                        <span className="ml-auto material-icons">
                                            {menuOpen.userManagement ? 'expand_less' : 'expand_more'}
                                        </span>
                                    </Link>
                                    <ul 
                                        id="user-management-menu" 
                                        className={`pl-8 space-y-1 mt-2 ${menuOpen.userManagement ? 'max-h-96' : 'max-h-0'} overflow-hidden transition-all duration-300`}
                                    >
                                        <li>
                                            <Link to="/permissions" className={`flex items-center p-2 sidebar-link ${activeLink === 'Permissions' ? 'active' : ''}`}>
                                                <span className="material-icons mr-3">lock_open</span>
                                                <span className="iconify text-lg mr-3" ></span>
                                                Permissions
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/roles" className={`flex items-center p-2 sidebar-link ${activeLink === 'Roles' ? 'active' : ''}`}>
                                                <span className="material-icons mr-3">assignment_ind</span>
                                                <span className="iconify text-lg mr-3" ></span>
                                                Roles
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/users" className={`flex items-center p-2 sidebar-link ${activeLink === 'Users' ? 'active' : ''}`}>
                                                <span className="material-icons mr-3">social_distance</span>
                                                <span className="iconify text-lg mr-3" ></span>
                                                Users
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        
                        {/* Session Section */}
                        <div>
                            <h5 className="text-xs font-semibold sidebar-heading mb-2 uppercase">Session</h5>
                            <ul className="space-y-2">
                                <li>
                                    <a href="/login" className="flex items-center p-2 sidebar-link logout-link">
                                        <span className="material-icons mr-3">logout</span>
                                        <span className="iconify text-lg mr-3" ></span>
                                        Logout
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;